export enum AppMessageType {
  Test = 'test',
  SpotNegativePriceStart = 'spot-negative-price-start',
  SpotNegativePriceStop = 'spot-negative-price-stop',
  UtilityLossStart = 'utility-loss-start',
  UtilityLossStop = 'utility-loss-stop',
  InverterProductionMWH = 'inverter-production-mwh',
  InverterDisconnected = 'inverter-disconnected',
  InverterConnected = 'inverter-connected',
  HeatWaterMaxTemperature = 'heat-water-max-temperature',
  WallboxStartCharging = 'wallbox-start-charging',
  WallboxStopCharging = 'wallbox-stop-charging',
  HomeLimitExceeded = 'home-limit-exceeded',
  HeatWaterLimitExceeded = 'heat-water-limit-exceeded',
  HeatPumpLimitExceeded = 'heat-pump-limit-exceeded',
  WallboxLimitExceeded = 'wallbox-limit-exceeded',
  SpotStartDischargingBattery = 'spot-start-discharging-battery',
  SpotStopDischargingBattery = 'spot-stop-discharging-battery',
  SpotStartChargingBattery = 'spot-start-charging-battery',
  SpotStopChargingBattery = 'spot-stop-charging-battery',
  SpotDailySummary = 'spot-daily-summary',
  BatteryMaxSOC = 'battery-max-soc',
  BatteryMinSOC = 'battery-min-soc',
  SpotDailyPrediction = 'spot-daily-prediction',
}
